import { JSX } from 'react';
import { ComponentParams, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';

interface C52BioDetailProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
}

export const Default = (props?: C52BioDetailProps): JSX.Element => {
  const id = props?.params?.RenderingIdentifier;

  return (
    <div className={`component ${props?.params?.styles}`} id={id ? id : undefined}>
      <div className="component-content">
        <p>C52BioDetail Component</p>
      </div>
    </div>
  );
};
